"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateGroupsLoader = void 0;
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const calcTimeInterval_1 = __importDefault(require("@opsbase/lib-time/helpers/calcTimeInterval"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const range_1 = __importDefault(require("lodash/range"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = require("react");
const useDataTree_1 = __importDefault(require("../../useDataTree"));
const useDataTreeActions_1 = __importDefault(require("../../useDataTreeActions"));
function DateGroupsLoader(props) {
    var _a, _b, _c;
    const { groupBy } = props;
    const { setGroupCollectionForGroupBy } = (0, useDataTreeActions_1.default)();
    const view = (0, useView_1.default)((_a = (0, useDataTree_1.default)()) === null || _a === void 0 ? void 0 : _a.viewId);
    const startDate = (_b = view === null || view === void 0 ? void 0 : view.filters.find(f => f.queryFieldKey === groupBy.queryFieldKey)) === null || _b === void 0 ? void 0 : _b.from;
    const endDate = (_c = view === null || view === void 0 ? void 0 : view.filters.find(f => f.queryFieldKey === groupBy.queryFieldKey)) === null || _c === void 0 ? void 0 : _c.to;
    const total = startDate === null || startDate === void 0 ? void 0 : startDate.diff(endDate, groupBy.timeInterval);
    (0, react_1.useEffect)(() => {
        const queryField = QueryFieldRegistry_1.default[groupBy.queryFieldKey];
        setGroupCollectionForGroupBy(groupBy, {
            loading: false,
            lastLoaded: new Date(),
            totalCount: total || 10,
            groups: (0, range_1.default)(total || 10).map(i => {
                const { from, to, label } = (0, calcTimeInterval_1.default)(groupBy.timeInterval, startDate || (0, moment_timezone_1.default)(), i, endDate);
                return Object.assign(Object.assign({}, groupBy), { id: from.toDate().getTime() + '', from,
                    to, title: (0, getFromStringOrFunction_1.getFromStringOrFunction)(queryField.label) + ': ' + label });
            }),
        });
    }, [endDate, groupBy, setGroupCollectionForGroupBy, startDate, total]);
    return null;
}
exports.DateGroupsLoader = DateGroupsLoader;
exports.default = DateGroupsLoader;
